import { render, staticRenderFns } from "./OrderLevel.vue?vue&type=template&id=c430f80c&"
import script from "./OrderLevel.vue?vue&type=script&lang=js&"
export * from "./OrderLevel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports